export const numberOfHourlyCardLoading = Array.from(Array(12).keys());